import React, { FC, useCallback, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'hooks';

import { FileUploader } from '../file-uploader';
import { ECGCompareItem } from '../ecg-compare-item';
import { PopUp, AlertDialog } from 'components';
import { studyActions } from 'utils/store';
import { ECGDetailsTable } from '../ecg-details-table';

type Props = {
  onClose: () => void;
};

export const StudyComparePopUp: FC<Props> = ({ onClose: onPopUpClose }) => {
  const { dbECGData, studyTableData } = useAppSelector(({ study }) => study);
  const dispatch = useAppDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [markFile, setMarkFile] = useState<null | File>(null);
  const [holterEcgFile, setHolterECGFile] = useState<null | File>(null);

  const onClose = useCallback(() => {
    dispatch(
      studyActions.saveHolterFiles({
        holterEcgFile,
        markFile,
        patientName: dbECGData?.patientName,
      }),
    );
    dispatch(studyActions.clearECGData());
    onPopUpClose();
  }, [dbECGData?.patientName, dispatch, holterEcgFile, markFile, onPopUpClose]);

  const handlePopUpClose = useCallback(() => {
    const popUpEcg = studyTableData.find(({ id }) => id === dbECGData?.id);
    if (!popUpEcg || popUpEcg?.status) {
      return onClose();
    }
    setIsDialogOpen(true);
  }, [dbECGData, onClose, studyTableData]);

  const onDialogCancel = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  const onDialogConfirm = useCallback(() => {
    setIsDialogOpen(false);
    onClose();
  }, [onClose]);

  if (!dbECGData) {
    return null;
  }

  return (
    <>
      <AlertDialog
        isOpen={isDialogOpen}
        title='Are you sure you want to leave without saving?'
        onCancel={onDialogCancel}
        onConfirm={onDialogConfirm}
        confirmButtonText='Exit'
        cancelButtonText='Cancel'
      />
      <PopUp isOpen={Boolean(dbECGData)} onPopUpToggle={handlePopUpClose}>
        <FileUploader
          markFile={markFile}
          holterFile={holterEcgFile}
          onMarkFileDownload={setMarkFile}
          onHolterFileDownload={setHolterECGFile}
        />
        <ECGCompareItem onAlignmentEnd={onClose} />
        <ECGDetailsTable />
      </PopUp>
    </>
  );
};
